<template>
  <Modal
    title="Adjust Late Fee"
    :saving="saving"
    @hide-modal="$emit('hide-modal')"
    @submit="handleSubmit"
  >
    <div>
      <TextField v-model="lateFee" placeholder="Late fee" />
    </div>
  </Modal>
</template>

<script>
import TextField from "@/components/TextField.vue";
import Modal from "../../components/Modal.vue";

export default {
  components: {
    TextField,
    Modal
  },
  props: {
    quote: {
      type: Object,
      default: null
    }
  },
  emits: ["hide-modal"],
  data() {
    return {
      lateFee: null
    };
  },
  methods: {
    handleSubmit() {}
  }
};
</script>

<style lang="scss" scoped></style>
